/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateEventInvitationDto } from '../models/work-create-event-invitation-dto';
import { WorkCreateEventInvitationPublicDto } from '../models/work-create-event-invitation-public-dto';
import { WorkEventInvitation } from '../models/work-event-invitation';
import { WorkEventInvitationStatusEnum } from '../models/work-event-invitation-status-enum';
import { WorkUpdateEventInvitationAdminDto } from '../models/work-update-event-invitation-admin-dto';
import { WorkUpdateEventInvitationOrganisatorDto } from '../models/work-update-event-invitation-organisator-dto';

@Injectable({ providedIn: 'root' })
export class WorkEventInvitationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventInvitationsV1ControllerRegisterPublic()` */
  static readonly EventInvitationsV1ControllerRegisterPublicPath = '/v1/event-invitations/public/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerRegisterPublic()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerRegisterPublic$Response(
    params: {
      body: WorkCreateEventInvitationPublicDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerRegisterPublicPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerRegisterPublic$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerRegisterPublic(
    params: {
      body: WorkCreateEventInvitationPublicDto
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventInvitationsV1ControllerRegisterPublic$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerFindByAccessKey()` */
  static readonly EventInvitationsV1ControllerFindByAccessKeyPath = '/v1/event-invitations/byAccessKey/{accessKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerFindByAccessKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerFindByAccessKey$Response(
    params: {
      accessKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerFindByAccessKeyPath, 'get');
    if (params) {
      rb.path('accessKey', params.accessKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerFindByAccessKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerFindByAccessKey(
    params: {
      accessKey: string;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventInvitationsV1ControllerFindByAccessKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerCheckIn()` */
  static readonly EventInvitationsV1ControllerCheckInPath = '/v1/event-invitations/checkIn/{accessKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerCheckIn()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerCheckIn$Response(
    params: {
      accessKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerCheckInPath, 'patch');
    if (params) {
      rb.path('accessKey', params.accessKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerCheckIn$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerCheckIn(
    params: {
      accessKey: string;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventInvitationsV1ControllerCheckIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerFindByEventId()` */
  static readonly EventInvitationsV1ControllerFindByEventIdPath = '/v1/event-invitations/byEvent/{eventId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerFindByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerFindByEventId$Response(
    params: {
      eventId: number;
      invitationStatus: WorkEventInvitationStatusEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEventInvitation>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerFindByEventIdPath, 'get');
    if (params) {
      rb.path('eventId', params.eventId, {});
      rb.query('invitationStatus', params.invitationStatus, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEventInvitation>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerFindByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerFindByEventId(
    params: {
      eventId: number;
      invitationStatus: WorkEventInvitationStatusEnum;
    },
    context?: HttpContext
  ): Observable<Array<WorkEventInvitation>> {
    return this.eventInvitationsV1ControllerFindByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEventInvitation>>): Array<WorkEventInvitation> => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerFindPublicInvitationsByEventId()` */
  static readonly EventInvitationsV1ControllerFindPublicInvitationsByEventIdPath = '/v1/event-invitations/byEvent/{eventId}/public';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerFindPublicInvitationsByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerFindPublicInvitationsByEventId$Response(
    params: {
      eventId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEventInvitation>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerFindPublicInvitationsByEventIdPath, 'get');
    if (params) {
      rb.path('eventId', params.eventId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEventInvitation>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerFindPublicInvitationsByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerFindPublicInvitationsByEventId(
    params: {
      eventId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkEventInvitation>> {
    return this.eventInvitationsV1ControllerFindPublicInvitationsByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEventInvitation>>): Array<WorkEventInvitation> => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerCreate()` */
  static readonly EventInvitationsV1ControllerCreatePath = '/v1/event-invitations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerCreate$Response(
    params: {
      body: WorkCreateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerCreate(
    params: {
      body: WorkCreateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.eventInvitationsV1ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerDelete()` */
  static readonly EventInvitationsV1ControllerDeletePath = '/v1/event-invitations/{id}';

  /**
   * Required permissions: events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV1ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventInvitationsV1ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerUpdate()` */
  static readonly EventInvitationsV1ControllerUpdatePath = '/v1/event-invitations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEventInvitationAdminDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEventInvitationAdminDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventInvitationsV1ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV1ControllerUpdateAsOrganisator()` */
  static readonly EventInvitationsV1ControllerUpdateAsOrganisatorPath = '/v1/event-invitations/{id}/organisator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV1ControllerUpdateAsOrganisator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerUpdateAsOrganisator$Response(
    params: {
      id: number;
      body: WorkUpdateEventInvitationOrganisatorDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsService.EventInvitationsV1ControllerUpdateAsOrganisatorPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV1ControllerUpdateAsOrganisator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV1ControllerUpdateAsOrganisator(
    params: {
      id: number;
      body: WorkUpdateEventInvitationOrganisatorDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventInvitationsV1ControllerUpdateAsOrganisator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
